export default "__VITE_ASSET__a4dd3d50__"